export default __webpack_public_path__ + "static/media/logo_scoop.8c031686.svg";